import React from 'react';
import { ArrowRight } from 'lucide-react';
const points = [{
  num: '01',
  emoji: '😩',
  title: 'Vous arrivez en cours sans savoir exactement ce que vous allez donner.',
  desc: "Vous improvisez et les élèves remarquent qu'il n'y a pas de plan clair derrière.",
  feeling: 'Insécurité'
}, {
  num: '02',
  emoji: '📉',
  title: 'Vos élèves ne progressent pas visiblement.',
  desc: "Vous n'avez pas de séquence claire de niveau à niveau et beaucoup abandonnent avant 3 mois.",
  feeling: 'Frustration'
}, {
  num: '03',
  emoji: '🔄',
  title: 'Toujours les mêmes 10 ou 15 postures.',
  desc: "Vous répétez la même chose car vous n'avez pas plus de matériel prêt, et les élèves s'ennuient.",
  feeling: 'Stagnation'
}, {
  num: '04',
  emoji: '👥',
  title: 'Groupes avec niveaux mélangés = chaos.',
  desc: 'Vous ne savez pas comment adapter la même posture pour débutants et avancés dans le même cours.',
  feeling: 'Débordement'
}, {
  num: '05',
  emoji: '😨',
  title: 'Élèves avec blessures ou conditions spéciales.',
  desc: "Vous ressentez de l'insécurité technique en travaillant avec hernies, grossesse ou seniors.",
  feeling: 'Peur'
}, {
  num: '06',
  emoji: '💼',
  title: 'Vous voulez être reconnu comme professionnel.',
  desc: 'Vous cherchez à offrir un système sérieux et moderne — pas des cours improvisés qui ne justifient pas ce que vous facturez.',
  feeling: 'Aspiration'
}];
export function ForWhomSection() {
  return <section className="w-full bg-bg-dark py-16 sm:py-24 px-4 relative overflow-hidden" data-id="element-182">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-primary/10 rounded-full blur-[100px] pointer-events-none" data-id="element-183"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-secondary/8 rounded-full blur-[100px] pointer-events-none" data-id="element-184"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-185">
        <div className="text-center mb-10 sm:mb-12" data-id="element-186">
          <p className="inline-block bg-primary/10 text-primary font-bold uppercase tracking-wider text-[11px] sm:text-xs px-3 py-1.5 rounded-full border border-primary/20 mb-4" data-id="element-187">
            👀 C'est pour vous si…
          </p>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main mb-4 tracking-tight" data-id="element-188">
            Vous reconnaissez-vous dans{' '}
            <span className="text-primary" data-id="element-189">l'une de ces scènes ?</span>
          </h2>
          <p className="text-text-sec text-base sm:text-lg max-w-xl mx-auto" data-id="element-190">
            Si vous vous identifiez à{' '}
            <span className="text-text-main font-bold" data-id="element-191">2 ou plus</span>, YOGA
            CLÉ EN MAIN™ a été conçu exactement pour vous.
          </p>
        </div>

        <div className="space-y-3 sm:space-y-4" data-id="element-192">
          {points.map((point, i) => <div key={i} className="flex items-start gap-4 sm:gap-5 bg-bg-alt rounded-2xl p-5 sm:p-6 border border-border-light hover:border-primary/40 hover:-translate-y-0.5 hover:shadow-[0_12px_28px_-10px_rgba(139,111,191,0.25)] transition-all duration-300 group" data-id="element-193">
              <div className="flex flex-col items-center flex-shrink-0 gap-1.5" data-id="element-194">
                <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-gradient-to-br from-primary/15 to-primary/5 border border-primary/25 flex items-center justify-center text-xl sm:text-2xl shadow-inner" data-id="element-195">
                  {point.emoji}
                </div>
                <span className="text-primary/70 font-black text-[10px] sm:text-xs leading-none" data-id="element-196">
                  {point.num}
                </span>
              </div>

              <div className="flex-1 min-w-0" data-id="element-197">
                <div className="flex flex-wrap items-center gap-2 mb-1.5" data-id="element-198">
                  <h3 className="text-text-main text-base sm:text-xl font-bold leading-snug" data-id="element-199">
                    {point.title}
                  </h3>
                  <span className="text-primary text-[10px] sm:text-xs font-bold uppercase tracking-wider bg-primary/10 px-2 py-0.5 rounded-full border border-primary/15" data-id="element-200">
                    {point.feeling}
                  </span>
                </div>
                <p className="text-text-sec text-sm sm:text-base font-medium leading-relaxed" data-id="element-201">
                  {point.desc}
                </p>
              </div>

              <div className="hidden sm:flex flex-shrink-0 items-center self-center" data-id="element-202">
                <div className="w-7 h-7 rounded-full border-2 border-border-light group-hover:border-cta-green group-hover:bg-cta-green/10 transition-colors flex items-center justify-center" data-id="element-203">
                  <span className="text-cta-green font-bold text-sm opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-204">
                    ✓
                  </span>
                </div>
              </div>
            </div>)}
        </div>

        <div className="mt-10 sm:mt-12 bg-gradient-to-br from-primary/10 via-bg-alt to-cta-green/[0.06] border border-primary/20 rounded-2xl p-6 sm:p-8 text-center relative overflow-hidden" data-id="element-205">
          <p className="text-text-main font-bold text-lg sm:text-xl mb-2" data-id="element-206">
            ✋ Vous vous êtes reconnu dans{' '}
            <span className="text-primary" data-id="element-207">2 ou plus</span> ?
          </p>
          <p className="text-text-sec text-sm sm:text-base mb-5 sm:mb-6" data-id="element-208">
            Alors ce Kit a été fait pour vous. Combien de cours allez-vous
            encore improviser ?
          </p>
          <a href="#pricing" className="inline-flex items-center justify-center gap-2 bg-cta-green hover:bg-cta-green-hover text-white font-black text-sm sm:text-base px-6 sm:px-8 py-3 sm:py-3.5 rounded-xl transition-all shadow-[0_10px_25px_-8px_rgba(15,139,111,0.5)]" data-id="element-209">
            Je veux le Pack complet
            <ArrowRight className="w-4 h-4" data-id="element-210" />
          </a>
        </div>
      </div>
    </section>;
}